import { Component } from '@angular/core';
import { HeroImageComponent } from '../../../shared/components/hero-image/hero-image.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { PartnersVoivodeshipsComponent } from '../../shared/components/partners-voivodeships/partners-voivodeships.component';

@Component({
    selector: 'app-voivodeships',
    templateUrl: './voivodeships.component.html',
    styleUrls: ['./voivodeships.component.scss'],
    imports: [HeroImageComponent, TitleComponent, PartnersVoivodeshipsComponent],
})
export class VoivodeshipsComponent {}
